import { Link } from "react-router-dom";
import { WebpHeaderPattern } from "../assets";

export default function MegaMenuContent({ data, onClickAway }) {
  return (
    <div className="megamenu__content__column__content__wrapper">
      <img
        loading="lazy"
        className="megamenu__content__column__content__img"
        src={WebpHeaderPattern}
        alt={data?.title}
      />
      <Link
        to={data?.contentLink}
        className="megamenu__content__column__content"
      >
        <div className="megamenu__content__column__title">{data?.title}</div>
        <div className="megamenu__content__column__info">{data?.content}</div>
        <Link
          to={data?.contentLink}
          onClick={onClickAway}
          className="megamenu__content__column__btn"
        >
          Learn more
        </Link>
      </Link>
      <div className="megamenu__content__img">
        <img
          loading="lazy"
          src={data?.img}
          alt=" At AFF, we pioneer evocative aromas and tastes that inspire and endure. As an ambitious trailblazer in Asia, we envision a world where every Scent tells a story, and every Flavor is a journey AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey ,AdvancedFF, a leader in global Flavors & Fragrances, offers cutting-edge aromatic solutions, bespoke scents, and innovative flavor creations. With a commitment to excellence, our natural extracts, culinary aromas, and custom fragrance formulations redefine sensory experiences. Explore our diverse range of gourmet essences, aroma compounds, and unique fragrances crafted with expertise. From scent marketing to personalized aromatics, our top-rated flavor and fragrance design elevate culinary sensations. AdvancedFF sets the standard in fragrance trends, delivering premium scents, bespoke flavoring, and unparalleled fragrance diversity. Experience the artistry of AdvancedFF, where advanced technology meets olfactory mastery for a world-class sensory journey,advancedffwebsite aff  aff website   advancedff advancedff.com advancedff advancedff advancedgg advancedff
advancedgg affwebsite  Advanced Flavors & Fragrances Pte. Ltd.
Advanced Flavors & Fragrances Pte. Ltd.
Advanced Flavors and  Flavors & Fragrances Pte. Ltd.
advnacedff   flavour flavour singapore advancedff-img"
        />
      </div>
    </div>
  );
}
